import useEffectiveMake from './useEffectiveMake';
import useEffectiveModel from './useEffectiveModel';
import useEffectiveYear from './useEffectiveYear';

export default function useVehicleName(): string {
  const year = useEffectiveYear();
  const make = useEffectiveMake();
  const model = useEffectiveModel();

  return [year, make, model].filter(Boolean).join(' ');
}
